import environment from '../environment/index.js';
var nextRedirect = {
  toLogin: function () {
    if (location.host.includes('dev-')) {
      var isHash = location.href.includes('/#/');
      return location.href = isHash ? location.origin + "/#/login" : location.origin + "/login";
    }
    //@ts-ignore
    if (window.__POWERED_BY_QIANKUN__) {
      // qiankun内，记录失效地址，
      // 	location.href = `/login`;
      // } else {
      sessionStorage.setItem('redirectUrl', location.href);
    }
    location.href = "https://" + environment.getApiEnv() + "next.gaodun.com/login";
  },
  toRedirect: function (redirectUrl, whiteList) {
    // if (location.host.includes('dev-')) {
    // 	//dev不生效
    // 	return;
    // }
    if (whiteList && whiteList.length > 0) {
      var isReturn_1 = false;
      whiteList.map(function (item) {
        if (isReturn_1 == false) {
          isReturn_1 = redirectUrl.includes(item);
        }
      });
      if (isReturn_1) {
        return;
      }
    }
    //@ts-ignore
    if (location.href.includes('/login') && !window.__POWERED_BY_QIANKUN__) {
      location.href = "https://" + environment.getApiEnv() + "next.gaodun.com/login";
      return;
    }
    //@ts-ignore
    if (!window.__POWERED_BY_QIANKUN__) {
      //老项目
      location.href = "https://" + environment.getApiEnv() + "next.gaodun.com/system" + (redirectUrl.indexOf('/') === 0 ? redirectUrl : '/' + redirectUrl);
    }
  },
  toHome: function () {
    if (location.host.includes('dev-')) {
      return;
    }
    //@ts-ignore
    if (!window.__POWERED_BY_QIANKUN__) {
      location.href = "https://" + environment.getApiEnv() + "next.gaodun.com/list";
    }
  }
};
export default nextRedirect;